module.exports = new __parcel__URL__("BAT.1212afba.svg").toString();